<app-dashboard-mobile-menu></app-dashboard-mobile-menu>
<div class="container student-classes-wrapper mt-2">
    <div class="student-tab student-tab-classes">
        <div class="student-tab__header">
            <span class="student-tab__text">Join a class:</span>
            <form
                #f="ngForm"
                (ngSubmit)="submitJoinClass($event, rosterCodeInput)"
                name="joinClassForm"
                novalidate
            >
                <input
                    #rosterCodeInput="ngModel"
                    [(ngModel)]="rosterCode"
                    class="student-tab__input"
                    name="rosterCode"
                    pattern="[a-zA-Z0-9]+"
                    placeholder="Enter code e.g., 1234banana"
                    required
                    type="text"
                />
                <input
                    class="student-tab__button btn gtm-student-join-a-class"
                    id="join-btn"
                    type="submit"
                    value="Go"
                />
            </form>
            <p *ngIf="f.submitted && !rosterCodeInput.dirty">This field is required.</p>
            <p *ngIf="f.submitted && rosterCodeInput.dirty && rosterCodeInput.invalid">
                Invalid roster code.
            </p>
        </div>
        <div class="student-tab__body">
            <div
                class="row-auto classListing__header tableListing__header justify-content-md-between"
            >
                <div class="col-xs-5 col-tablet-5 col-md-6 col-lg-6 ps-4">Class Name</div>
                <div class="col-xs-5 col-tablet-5 col-md-4 col-lg-4">Teacher</div>
                <div class="tableListing__header__edit col-xs-2 col-tablet-2 col-md-2 col-lg-2">
                    Delete
                </div>
            </div>

            <div *ngIf="classes.length === 0" class="tableListing__row__empty">
                <span>You have not joined any classes. Enter a code to join a class.</span>
            </div>

            <div
                *ngFor="let studentClass of classes"
                class="row-auto justify-content-between classListing__row tableListing__row"
            >
                <div class="tableListing__row__name col-xs-5 col-tablet-5 col-md-6 col-lg-6">
                    {{ studentClass.rosterName | safeTruncate: 40 }}
                </div>
                <div class="tableListing__row__name col-xs-5 col-tablet-5 col-md-4 col-lg-4">
                    {{ studentClass.teacherName | safeTruncate: 40 }}
                </div>
                <div class="tableListing__row__delete col-xs-2 col-tablet-2 col-md-2 col-lg-2">
                    <a
                        (click)="leaveClass($event, studentClass)"
                        aria-label="delete"
                        href="#"
                        role="button"
                    >
                        <i class="lm lm-trash"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
